module.exports = __webpack_public_path__ + "img/loading.b610d46d.png";